import * as React from 'react'

import { LoginHeading } from '@ally/ally-login'
import { Button, Space } from '@ally/metronome-ui'
import { AddAutoAccountProps } from '@ally/transmitigator'

import { useTransmit } from '../../TransmitContext'
import { StyledTextBody } from '../Shared'

const AddAutoAccountContent: React.FC<AddAutoAccountProps> = ({
  onComplete,
  status,
  error,
}) => {
  const { hostServices } = useTransmit()

  React.useEffect(() => {
    hostServices?.analytics.trackPageView({
      eventType: 'pageview',
      pageName: 'AOS:Login:We Are Adding Your New Account',
    })
  }, [])

  return (
    <>
      <LoginHeading title="We're adding your new account." />

      <Space mb="lg">
        <StyledTextBody size="sm" tag="p">
          You&apos;ll now be able to manage everything in one spot, with one set
          of credentials. We just need you to agree to the terms and confirm
          your electronic consent.
        </StyledTextBody>
      </Space>

      <Button
        allytmln="continue"
        loading={status === 'Loading'}
        onClick={onComplete}
        text="Continue"
        type="submit"
        variant="primary"
      />
    </>
  )
}

export const AddAutoAccount: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'AddAutoAccount') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <AddAutoAccountContent {...activeScreen.payload} />
}
